// extracted by mini-css-extract-plugin
module.exports = {"page-title":"xxjze","icon":"kfiSk","label":"nmBPK"};